const prefix = "far";
const iconName = "calendar";
const width = 448;
const height = 512;
const unicode = "f133";
const svgPathData = "M152 64H296V24C296 10.75 306.7 0 320 0C333.3 0 344 10.75 344 24V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H104V24C104 10.75 114.7 0 128 0C141.3 0 152 10.75 152 24V64zM48 448C48 456.8 55.16 464 64 464H384C392.8 464 400 456.8 400 448V192H48V448z";
export const faCalendar = {
    prefix,
    iconName,
    icon: [width, height, [], unicode, svgPathData],
};
